import React from 'react';
import CardTournamentInfo from './CardTournamentInfo';
import './Cards.css';
import './HeroSection.css'
import { useLang } from '../i18n';

function U17Info() {
  const { t } = useLang();
  return (
    <div>
      <div className='cards'>
        <h1>{t('tournament.infoTitle')}</h1>
        <div className='cards__container'>
          <div className='cards__wrapper'>
            <ul className='cards__items'>
              <CardTournamentInfo 
                label1={t('tournament.entryFees')}
                text1={t('tournament.singles40')}
                text2={t('tournament.doubles30')}
                text5={t('tournament.feesPayment')}
              />
              <CardTournamentInfo 
                label1={t('tournament.managersMeeting')}
                text2={t('tournament.meetingU17')}
                label2={t('tournament.shuttlesLabel')}
                text4={t('tournament.shuttlesBrand')}
              />
            </ul>

            <div className='table-wrapper'>
            <table className='table'>
              <thead>
                <tr>
                  <th>
                    {t('tournament.day25')}
                    <span className='label time'>9:00</span>
                  </th>
                  <th>
                    {t('tournament.day26')}
                    <span className='label time'>9:00</span>
                  </th>
                  <th>
                    {t('tournament.day27')}
                    <span className='label time'>9:00</span>
                  </th>
                </tr>
              </thead> 
              <tbody>
                <tr>   {/* first row */}
                  <td> {/* first column - Friday */}
                    <span className='label size'>64</span>
                    <span className='label discipline'>XD</span>
                    <span className='label discipline'>WS</span>
                    <span className='label discipline'>MS</span>   
                  </td>
                  <td> {/* second column - Saturday */}
                    <span className='label size'>32</span> 
                    <span className='label discipline'>XD</span>
                    <span className='label discipline'>WS</span>
                    <span className='label discipline'>MS</span>
                  </td>
                  <td> {/* third column - Sunday */}
                    <span className='label size'>SF</span>
                    <span className='label discipline'>XD</span>
                    <span className='label discipline'>WD</span>
                    <span className='label discipline'>MD</span>
                    <span className='label discipline'>WS</span>
                    <span className='label discipline'>MS</span>
                  </td>
                </tr>
                <tr>   {/* second row */}
                  <td> {/* first column - Friday */}
                    <span className='label size'>32</span> 
                    <span className='label discipline'>WD</span>
                    <span className='label discipline'>MD</span>
                  </td>
                  <td> {/* second column - Saturday */}
                    <span className='label size'>16</span> 
                    <span className='label discipline'>XD</span>
                    <span className='label discipline'>WD</span>
                    <span className='label discipline'>MD</span>
                    <span className='label discipline'>WS</span>
                    <span className='label discipline'>MS</span>
                  </td>
                  <td> {/* third column - Sunday */}
                    <span className='label size'>{t('tournament.finals')}</span> 
                    <span className='label discipline'>XD</span>
                    <span className='label discipline'>WD</span>
                    <span className='label discipline'>MD</span>
                    <span className='label discipline'>WS</span>
                    <span className='label discipline'>MS</span>
                  </td>
                </tr>
                <tr>   {/* third row */}
                  <td>-</td> {/* first column - Friday */}
                  <td> {/* second column - Saturday */}
                    <span className='label size'>QF</span> 
                    <span className='label discipline'>XD</span>
                    <span className='label discipline'>WD</span>
                    <span className='label discipline'>MD</span>
                    <span className='label discipline'>WS</span>
                    <span className='label discipline'>MS</span>  
                  </td>
                  <td>-</td> {/* third column - Sunday */}
                </tr>
              </tbody>
            </table>
          </div>
          
            <ul className='cards__items'>
            <CardTournamentInfo 
              text2={t('tournament.provisionalNote')}
              /*
              text4="For selecting the players/pairs the BEC European U17 Ranking from 26th August has been used."
              */
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default U17Info;